import "vant/es/radio/style";
import _Radio from "vant/es/radio";
import "vant/es/radio-group/style";
import _RadioGroup from "vant/es/radio-group";
import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "vant/es/datetime-picker/style";
import _DatetimePicker from "vant/es/datetime-picker";
import "vant/es/form/style";
import _Form from "vant/es/form";
import "vant/es/field/style";
import _Field from "vant/es/field";
import "vant/es/divider/style";
import _Divider from "vant/es/divider";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "vant/es/cell/style";
import _Cell from "vant/es/cell";
import "vant/es/cell-group/style";
import _CellGroup from "vant/es/cell-group";
import "vant/es/overlay/style";
import _Overlay from "vant/es/overlay";
import "vant/es/col/style";
import _Col from "vant/es/col";
import "vant/es/row/style";
import _Row from "vant/es/row";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/list/style";
import _List from "vant/es/list";
import "vant/es/tabbar/style";
import _Tabbar from "vant/es/tabbar";
import "vant/es/tabbar-item/style";
import _TabbarItem from "vant/es/tabbar-item";
import "vant/es/nav-bar/style";
import _NavBar from "vant/es/nav-bar";
import "vant/es/swipe/style";
import _Swipe from "vant/es/swipe";
import "vant/es/swipe-item/style";
import _SwipeItem from "vant/es/swipe-item";
import "vant/es/lazyload/style";
import _Lazyload from "vant/es/lazyload";
import "vant/es/grid/style";
import _Grid from "vant/es/grid";
import "vant/es/grid-item/style";
import _GridItem from "vant/es/grid-item";
import "vant/es/image/style";
import _Image from "vant/es/image";
import "vant/es/picker/style";
import _Picker from "vant/es/picker";
import "vant/es/image-preview/style";
import _ImagePreview from "vant/es/image-preview";
import "vant/es/pull-refresh/style";
import _PullRefresh from "vant/es/pull-refresh";
import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/index-bar/style";
import _IndexBar from "vant/es/index-bar";
import "vant/es/index-anchor/style";
import _IndexAnchor from "vant/es/index-anchor";
import "vant/es/notice-bar/style";
import _NoticeBar from "vant/es/notice-bar";
// 按需全局引入 vant组件
import Vue from 'vue';
Vue.use(_Radio).use(_RadioGroup).use(_Popup).use(_DatetimePicker).use(_Form).use(_Field).use(_Divider).use(_Icon).use(_Cell).use(_CellGroup).use(_Overlay).use(_Col).use(_Row).use(_Button).use(_List).use(_Tabbar).use(_TabbarItem).use(_NavBar).use(_Swipe).use(_SwipeItem).use(_Lazyload).use(_Grid).use(_GridItem).use(_Image).use(_Picker).use(_ImagePreview).use(_PullRefresh).use(_Loading).use(_IndexBar).use(_IndexAnchor).use(_NoticeBar);